module.exports = __webpack_public_path__ + "static/media/MATTLOGO1.16674048.png";